import { COLORS, FONTS } from '../../constants';

const styles = theme => {
  const minSm = theme.breakpoints.up('sm');

  return {
    root: {
      backgroundColor: COLORS.WHITE_DARK,

      '& table tbody td': {
        color: COLORS.GREY_DARK,
        backgroundColor: COLORS.WHITE,
        padding: '10px 20px',
      },
      '& table tbody tr': {
        borderBottom: `1px solid ${COLORS.GREY_LIGHTER}`,
      },
      '& table tbody td.description div': {
        display: 'block',

        '& a': {
          color: COLORS.GREY_DARK,
          fontWeight: 700,
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline',
          },
        },
      },
      '& table tbody td.description': {
        display: 'none',
      },
      '& table thead th.description': {
        display: 'none',
      },
      [minSm]: {
        '& table': {
          borderLeft: `1px solid ${COLORS.GREY_LIGHTER}`,
          borderRight: `1px solid ${COLORS.GREY_LIGHTER}`,
        },
        '& table tbody td.description': {
          display: 'table-cell',
        },
        '& table thead th.description': {
          display: 'table-cell',
          textAlign: 'left',
          paddingLeft: 20,
        },
      },
    },
    innerWrapper: {
      margin: '0 auto',
      padding: '40px 0',
      [minSm]: {
        padding: '40px 30px',
        maxWidth: 1200,
      },
    },
    introText: {
      padding: '0 20px',
      fontFamily: FONTS.PRIMARY,
      color: COLORS.GREY_DARK,
      marginBottom: 40,
      [minSm]: {
        padding: 0,
      },
    },
  };
};

export default styles;
